import { render, staticRenderFns } from "./CollegeList.vue?vue&type=template&id=13d32f62&scoped=true&"
import script from "./CollegeList.vue?vue&type=script&lang=js&"
export * from "./CollegeList.vue?vue&type=script&lang=js&"
import style0 from "./CollegeList.vue?vue&type=style&index=0&id=13d32f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d32f62",
  null
  
)

export default component.exports